import { Link } from 'react-router';
import { Box, Container, Typography, Stack } from '@mui/material';

const footerLinks = [
  { to: '/', label: 'Úvod' },
  { to: '/o-mne', label: 'O mně' },
  { to: '/psychoterapie', label: 'Psychoterapie' },
  { to: '/etopedicke-poradenstvi', label: 'Etopedické poradenství' },
  { to: '/kontakt', label: 'Kontakt' },
];

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#f9e8ce',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        py: 5,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        {/* Navigační odkazy */}
        <Stack
          component="nav"
          direction="row"
          spacing={{ xs: 2, sm: 3 }}
          justifyContent="center"
          flexWrap="wrap"
          sx={{ mb: 3 }}
        >
          {footerLinks.map((link) => (
            <Typography
              key={link.to}
              component={Link}
              to={link.to}
              sx={{
                fontSize: '0.9rem',
                color: 'text.secondary',
                textDecoration: 'none',
                transition: 'color 0.2s ease',
                '&:hover': {
                  color: 'text.primary',
                },
              }}
            >
              {link.label}
            </Typography>
          ))}
        </Stack>

        {/* Kontaktní údaje */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 3 }}
          justifyContent="center"
          alignItems="center"
          sx={{ mb: 3 }}
        >
          <Typography
            component="a"
            href="tel:+420797677397"
            sx={{
              fontSize: '0.9rem',
              color: 'text.secondary',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': { color: 'text.primary' },
            }}
          >
            +420 797 677 397
          </Typography>
          <Typography
            component="a"
            href="mailto:hana.jarkovska@etoped.cz"
            sx={{
              fontSize: '0.9rem',
              color: 'text.secondary',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              '&:hover': { color: 'text.primary' },
            }}
          >
            hana.jarkovska@etoped.cz
          </Typography>
        </Stack>

        {/* Copyright */}
        <Typography
          variant="body2"
          sx={{
            textAlign: 'center',
            fontSize: '0.85rem',
            color: 'text.secondary',
            fontWeight: 400,
          }}
        >
          © {currentYear} Mgr. Hana Jarkovská — Psychoterapie a etopedické poradenství
        </Typography>
      </Container>
    </Box>
  );
}
